import React, { useState } from "react";
import "./MenuFooter.scss"
import { useSelector } from "react-redux";
import email from "../../../assets/email.png"
import phone from "../../../assets/phone-call.png"
import location from "../../../assets/location-pin.png"
import facebook from "../../../assets/facebook.svg"
import insta from "../../../assets/instagram.svg"
import twitter from "../../../assets/twitter.svg"
import visa from "../../../assets/visa.svg"
import amex from "../../../assets/amex.svg"
import apple from "../../../assets/applePay.svg"
import masterCard from "../../../assets/masterCard.svg"
import arrow from "../../../assets/arrow-black.svg"
import moment from "moment";
import MapLocationComponent from "../MapLocationComponent";
import { useHistory } from "react-router";
import config from "react-global-configuration";



const MenuFooter = () => {
    const [show, setShow] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);
    const history = useHistory()
    const isNowWithinOpenHours = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        const nowMinutes = now.getHours() * 60 + now.getMinutes();

        const todaySchedule = companyDetails?.openingHours.find(day => day.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed || !todaySchedule.OpenHours.length) {
            return false;
        }
        for (const range of todaySchedule.OpenHours) {
            const [startH, startM] = range.StartTime.split(':').map(Number);
            const [endH, endM] = range.EndTime.split(':').map(Number);

            const startMinutes = startH * 60 + startM;
            const endMinutes = endH * 60 + endM;
            if (startMinutes <= endMinutes) {
                if (nowMinutes >= startMinutes && nowMinutes <= endMinutes) {
                    return range;
                }
            } else {
                if (nowMinutes >= startMinutes || nowMinutes <= endMinutes) {
                    return range;
                }
            }
        }

        return null;
    }
    const isNowNotWithinOpenHours = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });

        const todaySchedule = companyDetails?.openingHours.find(day => day.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed || !todaySchedule.OpenHours.length) {
            return false;
        }
        let time = {
            StartTime: todaySchedule.OpenHours[0].StartTime,
            EndTime: todaySchedule.OpenHours[todaySchedule.OpenHours.length - 1].EndTime
        }

        return time;
    }
    const hasTodayEndTimePassed = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let nowMinutes = now.getHours() * 60 + now.getMinutes();

        const today = companyDetails?.openingHours.find(day => day.Day === currentDay);
        if (!today || today.Closed || !today.OpenHours.length) return true;

        return today.OpenHours.every(range => {
            const [startH, startM] = range.StartTime.split(':').map(Number);
            const [endH, endM] = range.EndTime.split(':').map(Number);

            const startMinutes = startH * 60 + startM;
            let endMinutes = endH * 60 + endM;

            const isOvernight = endMinutes <= startMinutes;

            if (isOvernight) {
                endMinutes += 24 * 60;

                if (nowMinutes < startMinutes) {
                    nowMinutes += 24 * 60;
                }
            }

            return nowMinutes > endMinutes;
        });
    };


    return (
        <div className="Menu-Footer">
            {history.location.pathname === '/' && companyDetails?.settings?.ShowAddressInMap &&
                <MapLocationComponent lat={companyDetails?.address?.lat}
                    lng={companyDetails?.address?.lng}
                />}
            <div className="footer-innwr">
                <div className="footer-innwr-right">
                    <div className="menu-header-inner-header">
                        <div className="name">{companyDetails.shopName}</div>
                        {config.get('Theme') !== 'Hospitality-Default-V3-REGAL' ? <div className="address">
                            Fresh flavors that find you, fast.
                        </div> : ""}
                        <div className="foote-link-icon">
                            {company?.SocialMedias
                                ?.facebook && company?.SocialMedias
                                    ?.facebook !== "" && <img alt="" src={facebook} className="link-icon"
                                        onClick={() => {
                                            window.open(company?.SocialMedias
                                                ?.facebook, '_blank')
                                        }} />}
                            {company?.SocialMedias
                                ?.x && company?.SocialMedias
                                    ?.x !== "" && <img alt="" src={twitter} className="link-icon"
                                        onClick={() => {
                                            window.open(company?.SocialMedias
                                                ?.x, '_blank')
                                        }} />}
                            {company?.SocialMedias
                                ?.instagram && company?.SocialMedias
                                    ?.instagram !== "" && <img alt="" src={insta} className="link-icon"
                                        onClick={() => {
                                            window.open(company?.SocialMedias
                                                ?.instagram, '_blank')
                                        }} />}
                        </div>
                    </div>
                </div>
                {/* <div className="menu-header-inner">
                    <div className="name">Quick Links</div>
                    {pages.map((page, key) => {
                        return (<div className="address" key={key}>{page}
                        </div>)
                    })}
                </div> */}
                <div className="menu-header-inner">
                    <div className="name">Contact Us</div>
                    <div className="address">
                        {companyDetails.email &&
                            <div className="cont"><img alt="" src={email} />{companyDetails.email}</div>}
                        {companyDetails.contactNumber && <div className="cont"><img alt="" src={phone} /> {companyDetails.contactNumber}    </div>}
                        <div className="cont"><img alt="" src={location} /><div>{companyDetails.address.line1},<br />
                            {companyDetails.address.city}, {companyDetails.address.postcode},<br /> {companyDetails.address.country}
                        </div> </div></div>
                </div>
                {companyDetails?.settings?.ShowOpeningHours &&
                    <div className="footer-mid">
                        <div className="name">Opening Hours</div>
                        <div className="open-times-container">
                            <div className="toda-val">Today ({moment().format("dddd")})</div>
                            {hasTodayEndTimePassed() ? <div className="toda-closed">Store is closed for today</div> : isNowWithinOpenHours() ? <div className="toda-open">Open Now: {moment(isNowWithinOpenHours()?.StartTime, "HH:mm").format('hh:mm a')} - {moment(isNowWithinOpenHours()?.EndTime, "HH:mm").format('hh:mm a')}</div> : <div className="toda-closed">Closed (opens at {moment(isNowNotWithinOpenHours()?.StartTime, "HH:mm").format('hh:mm a')})</div>}
                        </div>
                        {!show && <div className="show-content" onClick={() => {
                            setShow(!show)
                        }}>
                            Show business hours <img alt="" src={arrow} className="down" />
                        </div>}
                        {show && companyDetails?.openingHours?.map((open, key) => {
                            const now = new Date();
                            const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
                            let show = currentDay !== open.Day
                            return (show && <div key={key} className="opening-hours-text">
                                <div>{open.Day}</div><div>{open?.Closed ? "Closed" : open.OpenHours?.map((date, idx) => {
                                    return (
                                        <div key={idx}>{date.StartTime + " - " + date.EndTime}</div>
                                    )
                                })}</div>
                            </div>)
                        })}
                        {show && <div className="show-content"
                            onClick={() => {
                                setShow(!show)
                            }}>
                            Hide business hours <img alt="" src={arrow} className="up" />
                        </div>}
                    </div>}

            </div>
            <div className="witmeg-text">
                <div className="footer-card-icon">
                    <img alt="" src={visa} className="link-icon" />
                    <img alt="" src={amex} className="link-icon" />
                    <img alt="" src={masterCard} className="link-icon" />
                    <img alt="" src={apple} className="link-icon" />
                </div>
                <div className="text-cont-wite">© 2025 WITMEG. All rights reserved.
                </div></div>

        </div>


    )

}
export default MenuFooter